<template>
  <div class="space-y-3">
    <label
        v-for="answer in answers"
        :key="answer.id"
        class="flex items-start p-4 rounded-lg border-2 border-zinc-200 cursor-pointer transition-all hover:bg-gray-50"
    >
      <input
          type="radio"
          :value="answer.id"
          :checked="selectedAnswerId === answer.id"
          @change="handleSelect(answer.id)"
          class="sr-only"
      />
      <div
          class="flex-shrink-0 w-5 h-5 rounded-full border-2 border-primary mr-3 mt-0.5 flex items-center justify-center"
      >
        <div
            v-if="selectedAnswerId === answer.id"
            class="w-2.5 h-2.5 rounded-full bg-primary"
        ></div>
      </div>
      <span
          class="text-zinc-600"
          :class="selectedAnswerId === answer.id
          ? 'font-semibold '
          : 'font-normal'"
      >
        {{ answer.text }}
      </span>
    </label>
  </div>
</template>

<script setup>
const props = defineProps({
  answers: {
    type: Array,
    required: true
  },
  selectedAnswerId: {
    type: Number,
    default: null
  }
});

const emit = defineEmits(['select']);

const handleSelect = (answerId) => {
  emit('select', answerId);
};
</script>
